import { END_POINT } from "../constants/api.constants";
import { store } from "../store";

const {
  GET_SITE_SETTINGS,
  GET_JSON_DETAILS,
  GET_PAGE_DETAILS,
} = END_POINT;

export const getSiteSettingsAPI = async () => {
//   console.log({ token: store.getState().app.token });
  return await fetch(GET_SITE_SETTINGS, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getJsonDetailsAPI = async () => {
//   console.log({ token: store.getState().app.token });
  return await fetch(GET_JSON_DETAILS, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getPageDetailsAPI = async (slug) => {
  return await fetch(`${GET_PAGE_DETAILS}/${slug}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch((error) => {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};
